<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('company_infos') }} </h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>     
                    <li class="breadcrumb-item text-gray-600">{{ $t('create_company_infos') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li>   
                </ul> 
            </div>  
            <div class="d-flex align-items-center py-1">
                <router-link to="/Settings">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_settings') }} </span>
                    </button>
                </router-link> 
            </div>
        </div>
        <div class="content flex-row-fluid mt-4" id="kt_content">
            
        <div class="card  mb-5 mb-xl-10" v-if="licenceList.length > 0">
          <div class="card-body p-0">
            <div class="px-9 pt-7 card-rounded h-150px w-100 bg-primary">
              <div class="d-flex flex-stack">
                <h3 class="m-0 text-white fw-bold fs-3">{{ $t('user_licence') }}</h3> 
              </div> 
            </div>
            <div class="bg-body shadow-sm card-rounded mx-9 mb-5 px-5 py-5 position-relative z-index-1" style="margin-top: -100px">                    
              <div class="d-flex align-items-center mb-6" v-for="item in licenceList" v-bind:key="item">
                <div class="symbol symbol-45px w-240px me-5">
                    <div class="form-check form-switch form-check-custom mt-5">
                      <label class="form-check-label form-label mt-2" for="isActive">
                          {{ $t('subscription_payment_status') }}
                          <br>
                          <span class="text-success" v-if="item.payment_type == 1">{{ $t('active') }}</span>
                          <span class="text-danger" v-if="item.payment_type !== 1">{{ $t('passive') }}</span>
                      </label> 
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap w-100 ms-5">
                  <div class="mb-1 pe-3 flex-grow-1">
                    <span class="fs-8 fw-bold" :class="{'text-warning': item.package_type == 0, 'text-success': item.package_type !== 0 && item.period_end > 30, 'text-danger': (item.package_type !== 0 && item.period_end < 30) || item.period_end <= 0}">
                        <b class="badge badge-lg fw-bolder bg-body text-dark shadow-sm me-3"
                        :class="{'bg-warning': item.package_type !== 0 && item.period_end < 30, 
                                 'bg-success': item.package_type !== 0 && item.period_end > 30, 
                                 'bg-danger': item.package_type !== 0 && item.period_end < 10,
                                 'text-muted': item.package_type == 0 }">
                            {{$t('licences.' + item.licence_name)}}
                        </b>
                    </span>
                  </div> 
                  <div class="d-flex align-items-center" v-if="item.payment_type == 1">
                    <button type="button" class="btn btn-danger btn-sm" @click="this.onCancelMainLicenceSubscription(item)">
                      {{ $t('cancel_main_licence_subscription') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
            <div class="d-flex flex-column flex-lg-row">
                <div class="flex-lg-row-fluid me-lg-15 order-2 order-lg-1 mb-10 mb-lg-0">
                    <div class="card card-flush pt-3 mb-5 mb-xl-10">
                        <div class="card-header">
                            <div class="card-title">
                                <h2 class="fw-bold">{{ $t('product_details') }}</h2>
                            </div>
                        </div>

                        <div class="card-body pt-3">
                            <div class="mb-10">
                                <h5 class="mb-4">{{ $t('billing_address') }}:</h5>
                                <div class="d-flex flex-wrap py-5">
                                    <div class="flex-equal me-5">
                                        <table class="table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0">
                                            <tbody>
                                                <tr>
                                                    <td class="text-gray-500 min-w-175px w-175px">{{ $t('bill_to') }}:</td>
                                                    <td class="text-gray-800 min-w-200px">
                                                        <span class="text-gray-800 text-hover-primary">{{licenceDetails.company_email || ''}}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-gray-500">{{ $t('customer_name') }}:</td>
                                                    <td class="text-gray-800">
                                                        {{userData.company_name || ''}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-gray-500">{{ $t('address') }}:</td>
                                                    <td class="text-gray-800">
                                                        {{licenceDetails.company_address || ''}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-gray-500">{{ $t('phone') }}:</td>
                                                    <td class="text-gray-800"> {{licenceDetails.phone_country_code || ''}} {{licenceDetails.company_gsm || ''}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="flex-equal">
                                        <table class="table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0">
                                            <tbody>
                                                <tr>
                                                    <td class="text-gray-500 min-w-175px w-175px">{{ $t('subscribed_product') }}:</td>
                                                    <td class="text-gray-800 min-w-200px">
                                                        <span class="text-gray-800 text-hover-primary" v-if="licenceDetails.licence_name">
                                                            {{ $t('licences.' + licenceDetails.licence_name) }}
                                                        </span>
                                                        <span class="text-gray-500" v-else>-</span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="text-gray-500">{{ $t('subscription_fees') }}:</td>
                                                    <td class="text-gray-800">
                                                        {{licenceDetails.grand_total || '0'}} <b>{{userData.currency_code || ''}}</b>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="text-gray-500">{{ $t('billing_method') }}:</td>
                                                    <td class="text-gray-800">
                                                        <span v-if="licenceDetails.payment_type_name">
                                                            {{$t(licenceDetails.payment_type_name)}}
                                                        </span>
                                                        <span v-else class="text-gray-500">-</span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="text-gray-500">{{ $t('currency') }}:</td>
                                                    <td class="text-gray-800">{{userData.currency_code || ''}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-0">
                                <h5 class="mb-4"> {{ $t('subscribed_products') }} </h5>

                                <div class="table-responsive">
                                    <table class="table align-middle table-row-dashed fs-6 gy-4 mb-0">
                                        <thead>
                                            <tr
                                                class="border-bottom border-gray-200 text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                                <th class="min-w-150px">{{ $t('product') }}</th>
                                                <th class="min-w-125px text-center">{{ $t('user') }}</th>
                                                <th class="min-w-125px text-end" v-if="licenceDetails.payment_type == 2 || licenceDetails.package_type == 0">{{ $t('end_date') }}</th>
                                                <th class="min-w-125px text-end">{{ $t('price') }}</th>
                                                <th class="min-w-125px text-end">{{ $t('vat') }}</th>
                                                <th class="min-w-125px text-end">{{ $t('grand_total') }}</th>
                                            </tr>
                                        </thead>

                                        <tbody class="fw-semibold text-gray-800">
                                            <tr>
                                                <td>
                                                    <label class="w-150px" v-if="licenceDetails.licence_name">
                                                        {{ $t('licences.' + licenceDetails.licence_name) }}
                                                    </label>
                                                    <label class="w-150px text-gray-500" v-else>-</label>
                                                </td>
                                                <td class="text-center">{{licenceDetails.user_count || 0}}</td>
                                                <td class="text-end" v-if="licenceDetails.payment_type == 2 || licenceDetails.package_type == 0"> 
                                                    {{previewDate(licenceDetails.period_end)}} 
                                                    <div class="fw-normal text-gray-600 fs-7" v-if="licenceDetails.licence_remaining_day !== null">
                                                        <span v-if="licenceDetails.licence_remaining_day > 0">                                                            
                                                            {{ $t('licence_days_left', [parseInt(licenceDetails.licence_remaining_day)]) }}
                                                        </span>
                                                        <span v-else-if="licenceDetails.licence_remaining_day < 0">                                                            
                                                            {{ $t('expired_days_ago', [Math.abs(licenceDetails.licence_remaining_day)]) }}
                                                        </span>
                                                        <span v-else> {{ $t('expired_today') }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-end">
                                                    {{licenceDetails.price || '0'}}
                                                </td>
                                                <td class="text-end">
                                                    {{licenceDetails.vat_amount || '0'}}
                                                </td>
                                                <td class="text-end">
                                                    {{licenceDetails.grand_total || '0'}} <b>{{userData.currency_code || ''}}</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Data grid sections with safe guards -->
                    <div class="card card-flush pt-3 mb-5 mb-xl-10" v-if="licenceTransactionsList.length > 0">
                        <div class="card-header">
                            <div class="card-title">
                                <h2>{{ $t('transactions') }}</h2>
                            </div>
                        </div>
                        <div class="card-body pt-0">
                            <div class="table-responsive min-h-300px">
                                <DxDataGrid :show-borders="true" 
                                    :key="$i18n.locale"
                                    key-expr="id" 
                                    :data-source="licenceTransactionsList" 
                                    :allow-column-reordering="true"  
                                    :allow-column-resizing="true" 
                                    :column-auto-width="true" 
                                    :row-alternatin-enabled="true"
                                    :hover-state-enabled="true" 
                                    :show-row-lines="true" 
                                    @exporting="this.$onExporting($event , 'Licence-transactions')">

                                    <DxFilterRow :visible="true"/>
                                    <DxHeaderFilter :visible="true"/>
                                    <DxGroupPanel :visible="true"/>      
                                    <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                    <DxPaging :page-size="100"/>
                                    <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                                    <DxSearchPanel :visible="true"/>
                                    <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                                    
                                    <DxColumn data-field="period_end" :caption="$t('period')" data-type="date" format="dd.MM.yyyy" cell-template="period_end-cell-template" />
                                    <DxColumn data-field="licence_name" :caption="$t('licence')" cell-template="licence_name-cell-template"/>
                                    <DxColumn data-field="price" :caption="$t('price')" :sorting-method="this.$numericSort" />
                                    <DxColumn data-field="vat_amount" :caption="$t('vat')" :sorting-method="this.$numericSort" />
                                    <DxColumn data-field="grand_total" :caption="$t('total')" :sorting-method="this.$numericSort" />
                                    <DxColumn data-field="proration_amount" :caption="$t('proration_amount')" :sorting-method="this.$numericSort" />
                                    <DxColumn data-field="user_count" :caption="$t('user')" />
                                    <DxColumn data-field="payment_type_name" :caption="$t('payment_type')" cell-template="payment_type_name-cell-template" />
                                    <DxColumn data-field="status_name" :caption="$t('status')" cell-template="status_name-cell-template"/>
                                    <DxColumn data-field="payment_date" :caption="$t('payment_date')" data-type="date" format="dd.MM.yyyy" />
                                    <DxColumn data-field="next_billing_date" :caption="$t('next_billing_date')" data-type="date" format="dd.MM.yyyy" />
                                    <DxColumn data-field="canceled_at" :caption="$t('canceled_at')" data-type="date" format="dd.MM.yyyy" />                                    
                                    <DxColumn data-field="last_payment_error" :caption="$t('last_payment_error')" />
                                    <DxColumn data-field="document_limit" :caption="$t('document_limit')" />
                                    <DxColumn data-field="is_company_inquiry_active" :caption="$t('company_inquiry')" cell-template="is_company_inquiry_active-cell-template" />
                                    <DxColumn data-field="is_address_inquiry_active" :caption="$t('address_inquiry')" cell-template="is_address_inquiry_active-cell-template" />
                                    
                                    <template #period_end-cell-template="{ data }">
                                        <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1" v-if="data.data.current_period_start || data.data.current_period_end">
                                            {{previewDate(data.data.current_period_start)}} <br> {{previewDate(data.data.current_period_end)}}
                                        </span>
                                        <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1" v-else>
                                            {{previewDate(data.data.period_end)}}
                                        </span>
                                    </template>
                                    <template #licence_name-cell-template="{ data }">
                                        <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1" v-if="data.data.licence_name">
                                            {{$t('licences.' + data.data.licence_name)}}
                                        </span>
                                        <span v-else class="text-gray-500">-</span>
                                    </template>
                                    <template #status_name-cell-template="{ data }">
                                        <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1" v-if="data.data.status_name">
                                            {{$t(data.data.status_name)}}
                                        </span>
                                        <span v-else class="text-gray-500">-</span>
                                    </template>
                                    <template #payment_type_name-cell-template="{ data }">
                                        <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1" v-if="data.data.payment_type_name">
                                            {{$t(data.data.payment_type_name)}}
                                        </span>
                                        <span v-else class="text-gray-500">-</span>
                                    </template>
                                    <template #is_company_inquiry_active-cell-template="{ data }">
                                        <span>
                                            <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1">
                                                <i v-if="data.data.is_company_inquiry_active == 1" class="bi bi-check-circle fs-5 text-success"></i> 
                                                <div v-if="data.data.is_company_inquiry_active == 1" class="fs-8 text-gray-600">
                                                    <small class="text-muted" v-html="$t('request_count_per_period', { request: data.data.company_inquiry_rate_limit, period: data.data.company_inquiry_exceed_period + ' ' + getPeriodTypeName(data.data.company_inquiry_period_type) })"></small>
                                                </div>
                                                <i v-if="data.data.is_company_inquiry_active == 0" class="bi bi-x-circle fs-5 text-danger"></i>
                                            </span>
                                        </span>
                                    </template>
                                    <template #is_address_inquiry_active-cell-template="{ data }">
                                        <span>
                                            <span class="text-gray-800 fw-bolder align-middle text-hover-primary mb-1">
                                                <i v-if="data.data.is_address_inquiry_active == 1" class="bi bi-check-circle fs-5 text-success"></i> 
                                                <div v-if="data.data.is_address_inquiry_active == 1" class="fs-8 text-gray-600">
                                                    <small class="text-muted" v-html="$t('request_count_per_period', { request: data.data.address_inquiry_rate_limit, period: data.data.address_inquiry_exceed_period + ' ' + getPeriodTypeName(data.data.address_inquiry_period_type) })"></small>
                                                </div>
                                                <i v-if="data.data.is_address_inquiry_active == 0" class="bi bi-x-circle fs-5 text-danger"></i>
                                            </span>
                                        </span>
                                    </template>
                                </DxDataGrid>  
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-column flex-lg-row-auto w-lg-250px w-xl-300px mb-10 order-1 order-lg-2">
                    <div class="card card-flush mb-0 bgi-no-repeat bgi-position-y-top bgi-position-x-end shadow rounded bg-abstract-2">
                        <div class="card-header">
                            <div class="card-title">
                                <h2>{{ $t('summary') }}</h2>
                            </div>
                        </div>

                        <div class="card-body pt-0 fs-6">
                            <div class="mb-7">
                                <div class="d-flex align-items-center">
                                    <div class="d-flex flex-column">
                                        <span class="fs-4 fw-bold text-gray-900 text-hover-primary me-2">{{userData.company_name || ''}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="separator separator-dashed my-5"></div>
                            <div class="mb-7">
                                <h5 class="mb-4">{{ $t('product_details') }}</h5>
                                <div class="mb-0">
                                    <span class="badge badge-light-primary me-2" v-if="licenceDetails.licence_name">
                                        {{ $t('licences.' + licenceDetails.licence_name) }}
                                    </span>
                                    <span class="fw-semibold text-gray-600"> 
                                        {{licenceDetails.grand_total || '0'}} 
                                        <small class="fw-bold">{{userData.currency_code || ''}}</small>
                                        <small v-if="licenceDetails.payment_type == 1"> / {{ $t('month') }} </small>
                                        <small v-if="licenceDetails.payment_type == 2"> / {{ $t('year') }} </small>
                                    </span>
                                </div>
                            </div>
                            <div class="separator separator-dashed my-5"></div>
                            <div class="mb-10">
                                <h5 class="mb-4">{{ $t('subscription_details') }}</h5>
                                <table class="table fs-6 fw-semibold gs-0 gy-2 gx-2">
                                    <tbody>
                                        <tr class="">
                                            <td class="text-gray-500">{{ $t('licence_number') }}:</td>
                                            <td class="text-gray-800">{{licenceDetails.licence_number || ''}}</td>
                                        </tr>

                                        <tr class="">
                                            <td class="text-gray-500">{{ $t('started') }}:</td>
                                            <td class="text-gray-800"> {{previewDate(licenceDetails.created_at)}} </td>
                                        </tr>

                                        <tr class="">
                                            <td class="text-gray-500">{{ $t('status') }}:</td>
                                            <td>
                                                <span class="badge" :class="{'badge-warning': licenceDetails.status == 0, 'badge-info': licenceDetails.status == 1, 'badge-success': licenceDetails.status == 2}" v-if="licenceDetails.status_name"> 
                                                    {{$t(licenceDetails.status_name)}}
                                                </span>
                                                <span v-else class="text-gray-500">-</span>
                                            </td>
                                        </tr>
                                        <tr class="">
                                            <td class="text-gray-500">{{ $t('next_invoice') }}:</td>
                                            <td class="text-gray-800">{{previewDate(licenceDetails.period_end)}}</td>
                                        </tr>
                                        <tr class="">
                                            <td class="text-gray-500">{{ $t('remain') }}:</td>
                                            <td class="text-gray-800">{{licenceDetails.licence_remaining_day || 0}} {{ $t('day') }} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Modules section with safe guards -->
                    <div class="card card-flush mt-10 bgi-no-repeat bgi-position-y-top bgi-position-x-end shadow rounded bg-abstract-2" v-if="licenceDetails.licence_name">
                        <div class="w-100 card-body d-flex flex-column d-flex flex-column-fluid py-10 px-10">
                            <div class="mb-7">
                                <h3 class="text-gray-900 fw-bolder">
                                   {{$t('licences.' + licenceDetails.licence_name)}}
                                </h3>
                            </div>
                            <div class="w-100">
                                <div class="d-flex align-items-center">
                                    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">
                                        {{licenceDetails.user_count || 0}} {{ $t('active_users') }} 
                                    </span>
                                    <i class="bi bi-check-circle fs-3 text-success"></i>
                                </div>
                                
                                <div class="d-flex flex-column content-justify-center flex-grow-1" 
                                     v-for="moduleItem in getModuleTitles" 
                                     :key="moduleItem.id">                                    
                                    <div v-if="moduleItem && moduleItem.key_value" class="d-flex fs-6 fw-semibold align-items-center border-bottom border-2 border-primary my-5">
                                        <h5 class="my-3"> {{$t('licences.' + moduleItem.key_value)}} </h5>
                                    </div>
                                    
                                    <div class="d-flex fs-6 fw-semibold align-items-center my-1" 
                                        v-for="subItem in moduleItem.items" 
                                        :key="subItem.id">
                                        <span v-if="subItem && subItem.key_value" class="fw-semibold fs-6 text-gray-800 flex-grow-1 pe-3">
                                            {{$t('licences.' + subItem.key_value)}}
                                        </span>
                                        <i class="bi bi-check-circle fs-3 text-success"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling } from 'devextreme-vue/data-grid';

export default {
    name: "CompanyInfos",
    data() {
        return {
            userData: this.$getUser() || {},
            lists: [],
            licenceDetails: {
                company_email: '',
                company_address: '',
                phone_country_code: '',
                company_gsm: '',
                licence_name: '',
                grand_total: '0',
                payment_type_name: '',
                user_count: 0,
                period_end: null,
                licence_remaining_day: 0,
                price: '0',
                vat_amount: '0',
                payment_type: 0,
                licence_number: '',
                created_at: null,
                status: 0,
                status_name: '',
            },
            isProgressing: false,
            menuSelection: '/CompanyInfosHelppage',
            iconView: false,
            licenceTransactionsList: [],
            periodTypeList: [
                { id: 1, text: this.$t('minute') },
                { id: 2, text: this.$t('hour') },
                { id: 3, text: this.$t('day') },
                { id: 4, text: this.$t('week') },
                { id: 5, text: this.$t('month') },
                { id: 6, text: this.$t('year') },
            ],
            modules: [],
            licenceList: [],
        };
    },
    
    components: {
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling
    },
    
    computed: {        
        previewDate() {
            return (value) => {
                if (value) {
                    return moment(new Date(value)).format('DD.MM.YYYY')
                }
                return '';
            }
        },
        getPeriodTypeName() {
            return (value) => {
                if (value && this.periodTypeList) {
                    const period = this.periodTypeList.find(p => p.id == value);
                    return period ? period.text : '';
                }
                return '';
            } 
        },
        getModuleTitles() {
            if (!this.modules || this.modules.length === 0) {
                return [];
            }
            
            try {
                const parentModules = this.modules.filter(m => m && m.type == 1);
                
                return parentModules.map(parent => ({
                    ...parent,
                    items: this.modules.filter(child => 
                        child && child.parent_id == parent.id && child.parent_id !== 0
                    )
                }));
            } catch (error) {
                console.error('Error in getModuleTitles:', error);
                return [];
            }
        }
    },
    
    methods: {
        getData() {
            const parameters = {
                session_id: this.$getUser()?.session_id
            };  
            
            if (!parameters.session_id) {
                console.error('No session ID available');
                return;
            }
            
            axios.post('/api/Auth/GetCompanyInfos', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if (response.data && !response.data.error) {
                    this.licenceDetails = {
                        ...this.licenceDetails,
                        ...response.data.licence
                    };
                    this.licenceTransactionsList = response.data.transactions || [];
                    this.modules = response.data.modules || [];
                }                

                if(this.$getUser().is_quick_mode !== 1) {
                    this.getSubscriptions();
                }
            })
            .catch((error) => {
                console.error('❌ Error loading company info:', error);
            });
        },        
        async helpPageViewIcon() {
            const queryparameter = {
                session_id: this.$getUser()?.session_id,
                menu_selection: '/CompanyInfosHelppage'
            };
            
            if (!queryparameter.session_id) return;
            
            axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
            .then((response) => { 
                if (!response.data.error) { 
                    this.iconView = response.data;
                }
            })
            .catch((error) => {
                console.error('Error loading help page:', error);
            });
        },
        getSubscriptions() {
            const parameters = {
                session_id: this.$getUser().session_id,
            };  
            axios.post('/api/Auth/GetSubscriptions', parameters, {'Content-Type': 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.licenceList = response.data;
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        onCancelMainLicenceSubscription(item){
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_cancel_subscription'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
                cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('cancel_subscription'),
                icon: 'error'
            })
            .then((result) => {
                if (result.isConfirmed) {
                let subIdList = [];
                this.licenceList.forEach(element => {
                    subIdList.push(element.strsubid);
                });

                const params = {
                    session_id: this.$getUser().session_id, 
                    transaction_id: item.licence_transaction_id,
                    strsubids: subIdList
                };
                axios.post('api/Payment/CancelLicenceSubscriptionRequest', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.$signOutWithTimer(this.$t('session-terminated'), this.$t('subscription-has-been-cancelled-less-than-br-great'));
                    }
                })
                .catch(function (Error) {
                    console.error(Error);
                    this.$swal(this.$t('a_problem_occured'), this.$t('subscription_has_already_been'), 'error');
                    return;
                }); 
                }
            }); 
        }
    }, 
    
    created() {
        this.helpPageViewIcon();
        this.getData();
    }
}; 
</script>